import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

const TechnicitySelect = ({ value, onChange }) => {
  return (
    <Form.Group
      controlId="technicitySelect"
      className="d-flex align-items-center"
    >
      <Form.Label style={{ width: '250px' }}>Difficulté technique:</Form.Label>
      <Form.Control
        as="select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="EASY">Facile</option>
        <option value="MEDIUM">Intermédiaire</option>
        <option value="HARD">Difficile</option>
        <option value="VERY_HARD">Très difficile</option>
      </Form.Control>
    </Form.Group>
  )
}

TechnicitySelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TechnicitySelect
